<template>
    <div class="auto-catalog-filter">
        <kia-filter
                v-if="isKiaFilter"
                :typeList="typeList" :markList="markList"
                :defaultMark="currentMark" :defaultType="currentType"
                @selectType="value => currentType = value"
                @selectMark="value => currentMark = value"
                @sendResponse="value => responseData = value"
                @updateNumbers="value => dataNumber = value"/>
        <toyota-filter
                v-else-if="isToyotaFilter"
                :typeList="typeList" :markList="markList"
                :defaultMark="currentMark" :defaultType="currentType"
                @selectType="value => currentType = value"
                @selectMark="value => currentMark = value"
                @sendResponse="value => responseData = value"
                @updateNumbers="value => dataNumber = value"/>
        <infinity-filter
                v-else-if="isInfinityFilter"
                :typeList="typeList" :markList="markList"
                :defaultMark="currentMark" :defaultType="currentType"
                @selectType="value => currentType = value"
                @selectMark="value => currentMark = value"
                @sendResponse="value => responseData = value"
                @updateNumbers="value => dataNumber = value"/>
        <renault-filter
                v-else-if="isRenaultFilter"
                :typeList="typeList" :markList="markList"
                :defaultMark="currentMark" :defaultType="currentType"
                @selectType="value => currentType = value"
                @selectMark="value => currentMark = value"
                @sendResponse="value => responseData = value"
                @updateNumbers="value => dataNumber = value"/>
        <mercedes-filter
                v-else-if="isMercedesFilter"
                :typeList="typeList" :markList="markList"
                :defaultMark="currentMark" :defaultType="currentType"
                @selectType="value => currentType = value"
                @selectMark="value => currentMark = value"
                @sendResponse="value => responseData = value"
                @updateNumbers="value => dataNumber = value"/>
        <ssangyoung-filter
                v-else-if="isSsangyoungFilter"
                :typeList="typeList" :markList="markList"
                :defaultMark="currentMark" :defaultType="currentType"
                @selectType="value => currentType = value"
                @selectMark="value => currentMark = value"
                @sendResponse="value => responseData = value"
                @updateNumbers="value => dataNumber = value"/>
        <abarth-filter
                v-else-if="isAbarthFilter"
                :typeList="typeList" :markList="markList"
                :defaultMark="currentMark" :defaultType="currentType"
                @selectType="value => currentType = value"
                @selectMark="value => currentMark = value"
                @sendResponse="value => responseData = value"
                @updateNumbers="value => dataNumber = value"/>
        <base-filter
                v-else-if="isBaseFilter"
                :typeList="typeList" :markList="markList"
                :defaultMark="currentMark" :defaultType="currentType"
                @selectType="value => currentType = value"
                @selectMark="value => currentMark = value"
                @sendResponse="value => responseData = value"
                @updateNumbers="value => dataNumber = value"/>
        <div v-else>
            <nav aria-label="breadcrumb" role="navigation">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item" aria-current="page">{{currentType}}</li>
                    <li v-if="currentMark" class="breadcrumb-item" aria-current="page">{{currentMark}}</li>
                </ol>
            </nav>
            <div class="row">
                <div class="col-3 mt-3">
                    <el-select v-model="currentType" placeholder="Тип">
                        <el-option v-for="item in typeList"
                                   :key="item.value"
                                   :label="item.name"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-3 mt-3" v-if="currentType && markList.length > 0">
                    <el-select v-model="currentMark" placeholder="Марка">
                        <el-option v-for="item in markList"
                                   :key="item.value"
                                   :label="item.name"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <ul class="list-group mt-3" v-if="numberList.length > 0">
            <li v-for="(item,index) of numberList" :key="index" class="list-group-item disabled">{{item.name}}</li>
        </ul>
        <!--<div class="mt-5">-->
        <!--<pre>{{responseData}}</pre>-->
        <!--</div>-->
    </div>
</template>

<script>
import BaseFilter from './components/BaseFilter'
import KiaFilter from './components/KiaHyundai'
import ToyotaFilter from './components/ToyotaLexus'
import InfinityFilter from './components/Infinity'
import RenaultFilter from './components/Renault'
import MercedesFilter from './components/Mercedes'
import SsangyoungFilter from './components/Ssangyong'
import AbarthFilter from './components/Abarth'

export default {
  name: 'auto-catalog-filter',
  props: {
    application: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    AbarthFilter,
    SsangyoungFilter,
    RenaultFilter,
    KiaFilter,
    ToyotaFilter,
    InfinityFilter,
    BaseFilter,
    MercedesFilter
  },
  data () {
    return {
      responseData: {},

      currentType: '',
      currentMark: '',

      dataTypeAndMark: {},
      dataNumber: {}
    }
  },
  computed: {
    typeList () {
      const dataList = this.dataTypeAndMark.types
      return this.getListFromData(dataList, item => {
        return {
          name: item.name,
          value: item.value
        }
      })
    },
    markList () {
      if (this.currentType === '') {
        return []
      }
      if (!Array.isArray(this.dataTypeAndMark.types) && this.dataTypeAndMark.types.length === 0) {
        return []
      }
      for (const index in this.dataTypeAndMark.types) {
        if (this.currentType === this.dataTypeAndMark.types[index].value) {
          return this.getListFromData(this.dataTypeAndMark.types[index].marks, mark => {
            return {
              name: mark.name,
              value: mark.value
            }
          })
        }
      }
      return []
    },
    numberList () {
      const dataList = this.dataNumber
      return this.getListFromData(dataList, item => {
        return {
          name: item.number,
          value: item.number
        }
      })
    },
    isBaseFilter () {
      const type = [
        'CARS_FOREIGN', 'CARS_NATIVE', 'TRUCKS_NATIVE', 'TRUCKS_FOREIGN', 'BUS', 'SPECIAL_TECH_NATIVE',
        'SPECIAL_TECH_FOREIGN', 'AGRICULTURAL_MACHINERY', 'TRACTOR', 'ENGINE', 'MOTORCYCLE']
      const mark = [
        'GAZ_ENGINE',
        'ANDORIA_ENGINE',
        'AVIA',
        'BALKANCAR_ENGINE',
        'BALKANCAR',
        'BAW',
        'BEARFORD_ENGINE',
        'BEIFANG_BENCHI',
        'BYD',
        'CAMC',
        'CASE',
        'CATERPILLAR',
        'CF_MOTO',
        'CHENGGONG',
        'CHEVROLET',
        'CHEVROLET_SKD',
        'CHRYSLER_ENGINE',
        'CITROEN_SKD',
        'CNHTC_SINOTRUK',
        'CNHTC_SINOTRUK_ARCHIVE',
        'CUMMINS_ENGINE',
        'CUMMINS_ENGINE',
        'DAEWOO',
        'DAEWOO_SKD',
        'DAEWOO_ARCHIVE',
        'DAF',
        'DERWAYS',
        'DETVA',
        'DEUTZ_ENGINE',
        'DONGFENG_ENGINE',
        'DONGFENG',
        'DONGFENG',
        'DOOSAN',
        'EAGLE-WING',
        'FAW_ARCHIVE',
        'FAW',
        'FORD_SKD',
        'FORTSCHRITT',
        'FOTON',
        'FOTON',
        'GEELY',
        'GOLDEN_DRAGON',
        'HAFEI',
        'HANWOO',
        'HBXG',
        'HIDROMEK_ARCHIVE',
        'HIDROMEK',
        'HIGER',
        'HONDA_SKD',
        'HONDA_SKD',
        'HONEY_BEE',
        'IKARUS',
        'IRAN_KHODRO',
        'ISUZU_ENGINE',
        'ISUZU_SKD',
        'IVECO_ENGINE',
        'IVECO',
        'JAC',
        'JAGUAR_SKD',
        'JAWA',
        'JCB',
        'JEEP_SKD',
        'JIANSHE',
        'JMC',
        'KING_LONG',
        'KOMAT',
        'SU_ENGINE ',
        ' KOMAT',
        'SU',
        'LAND_ROVER_SKD',
        'LIFAN',
        'LIUGONG',
        'LOCUST',
        'MACDON',
        'MADARA',
        'MADARA',
        'MAHINDRA',
        'MAN_SKD',
        'MAN',
        'MAZDA_SKD',
        'MECANICA_CEAHLAU',
        'MERCEDES_BENZ_SKD',
        'MERCEDES_BENZ_SKD',
        'METAL-FACH_ARCHIVE',
        'METAL-FACH',
        'MITSUBER',
        'MITSUBISHI_SKD',
        'NEW_HOLLAND',
        'NISSAN_ENGINE',
        'OPEL_SKD',
        'PEUGEOT_SKD',
        'PORSCHE_SKD',
        'RENAULT_SKD',
        'RENAULT',
        'ROVER_SKD',
        'SAAB',
        'SAAB_SKD',
        'SARKANA_ZVAIGZNE',
        'SCANIA_SKD',
        'SDLG',
        'SHAANXI',
        'SHAANXI_FAST_GEAR',
        'SHANTUI',
        'SSANGYONG_SKD',
        'SUBARU_SKD',
        'SUZUKI',
        'SUZUKI_SKD',
        'SUZUKI_SKD',
        'TATA',
        'TATRA',
        'TEREX',
        'THERMO_KING',
        'TIGARBO',
        'TRACOM',
        'VERSATILE',
        'VOLVO',
        'VOLVO',
        'VOLVO_SKD',
        'VOLVO_SKD',
        'XCMG',
        'XIAMEN',
        'YANMAR_ENGINE',
        'YUCHAI_ENGINE',
        'YUTONG_ARCHIVE',
        'YUTONG',
        'ZETOR_ENGINE',
        'ZF',
        'ZONGSHEN',
        'AVTOKRAN',
        'AGRO',
        'AZLK',
        'ALTAJ',
        'AMZ_ENGINE',
        'AMKODOR_ARCHIVE',
        'AMKODOR',
        'ATZ',
        'BARNAULTRANSMASH_ARCHIVE_ENGINE',
        'BARNAULTRANSMASH_ENGINE',
        'BELAZ_ARCHIVE',
        'BELAZ',
        'BELAZ',
        'BELOVEZH_ARCHIVE',
        'BELOVEZH',
        'BELOCERKOVMAZ',
        'BOBRUJSKAGROMASH_ARCHIVE',
        'BOBRUJSKAGROMASH',
        'BOBRUJSKSELMASH',
        'BOGDAN',
        'BRYANSKIJ_ARSENAL_ARCHIVE',
        'BRYANSKIJ_ARSENAL',
        'BRYANSKIJ_ARSENAL',
        'BEHMZ',
        'VAZ_ARCHIVE',
        'VAZ',
        'VGTZ',
        'VSM',
        'VTZ_ARCHIVE_ENGINE',
        'VTZ_ENGINE',
        'VTZ',
        'VEHKS',
        'GAZ_ARCHIVE',
        'GAZ',
        'GAZ_ARCHIVE',
        'GAZ',
        'GAZPROM-KRAN',
        'GAKZ',
        'GEOMASH',
        'GIDROMASH',
        'GOMSELMASH',
        'GOMSELMASH_ARCHIVE',
        'DKZ',
        'DONEHKS',
        'DORMASH',
        'ELAZ',
        'ZAZ_ARCHIVE',
        'ZAZ',
        'ZZGT_ARCHIVE',
        'ZZGT',
        'ZID',
        'ZID',
        'ZIK',
        'ZIL',
        'ZIL_ARCHIVE',
        'ZIL_ARCHIVE',
        'ZIL',
        'ZLATEHKS',
        'ZMZ_ARCHIVE_ENGINE',
        'ZMZ_ENGINE',
        'IZH',
        'IZH',
        'IZH_ARCHIVE',
        'IZHNEFTEMASH',
        'IZHORSKIE_ZAVODY',
        'IMZ',
        'KAVZ',
        'KAZ',
        'KAMAZ_ENGINE',
        'KAMAZ_ARCHIVE',
        'KAMAZ_ARCHIVE',
        'KAMAZ_ARCHIVE_ENGINE',
        'KAMAZ',
        'KAMAZ',
        'KANASH',
        'KZK_ARCHIVE',
        'KZK',
        'KZKT',
        'KLEVER_ARCHIVE',
        'KLEVER',
        'KMZ',
        'KMZ_1_MAYA',
        'KOVROVEC',
        'KRAZ_ARCHIVE',
        'KRAZ',
        'KREDMASH',
        'KEHZ',
        'LAZ',
        'LZA',
        'LIAZ',
        'LIAZ_ARCHIVE',
        'LIDAGROPROMMASH',
        'LIDSELMASH',
        'LTZ',
        'LUAZ',
        'MAZ_ARCHIVE',
        'MAZ',
        'MAZ',
        'MAZ_ARCHIVE',
        'MAZ',
        'MASHTEKHREMONT',
        'MZKM_ARCHIVE',
        'MZKM',
        'MZKT',
        'MMZ',
        'MMZ_ARCHIVE_ENGINE',
        'MMZ_ENGINE',
        'MOAZ',
        'MOAZ',
        'MOAZ_ARCHIVE',
        'MOLDAGROTEKHNIKA',
        'MRMZ',
        'MTZ_ARCHIVE',
        'MTZ',
        'MTM',
        'MTM',
        'NEFAZ_ARCHIVE',
        'NEFAZ_ARCHIVE',
        'NEFAZ',
        'NEFAZ',
        'NEFAZ',
        'NKMZ',
        'OREL-POGRUZCHIK',
        'OSTA',
        'OTZ',
        'PAZ',
        'PAZ_ARCHIVE',
        'PENZADIZELMASH_ENGINE',
        'PROMTRAKTOR',
        'PTZ',
        'RASKAT',
        'RAF',
        'RMZ',
        'ROSTSELMASH_ARCHIVE',
        'ROSTSELMASH',
        'RUSSKAYA_MEKHANIKA',
        'RUSSKAYA_MEKHANIKA_ARCHIVE',
        'SAZ',
        'SALSKSELMASH',
        'SAREHKS',
        'SZAP_ARCHIVE',
        'SZAP',
        'SIBSELMASH',
        'SINERGIYA',
        'SMD_ENGINE',
        'STROJDORMASH',
        'STROMNEFTEMASH',
        'TVEHKS_ARCHIVE',
        'TVEHKS',
        'TEPLOSTAR_ENGINE',
        'TZA',
        'TKZ',
        'TMZ_ARCHIVE_ENGINE',
        'TMZ_ENGINE',
        'TMZ',
        'TONAR_ARCHIVE',
        'TONAR',
        'TORFMASH',
        'UAZ_ARCHIVE',
        'UAZ',
        'UVZ',
        'UVZ_ARCHIVE',
        'UMZ_ARCHIVE_ENGINE',
        'UMZ_ENGINE',
        'UMZ_-2',
        'UMPO',
        'UMPO',
        'UNISIBMASH',
        'URAL',
        'URAL_ARCHIVE',
        'URAL',
        'URALMASH',
        'HZTSSH',
        'HTZ_ARCHIVE',
        'HTZ',
        'CHERVONA_ZIRKA',
        'CHZTS',
        'CHMZ',
        'CHSDM',
        'CHTZ',
        'SHAAZ',
        'EHKSKO',
        'EHKSMASH',
        'EHLTRA_ENGINE',
        'YUMZ',
        'YURMASH',
        'YAMZ_ARCHIVE_ENGINE',
        'YAMZ_ENGINE']
      return this.getValueFilter(type, mark)
    },
    isKiaFilter () {
      const type = ['BUS', 'TRUCKS_FOREIGN', 'CARS_FOREIGN']
      const mark = ['KIA', 'HYUNDAI']
      return this.getValueFilter(type, mark)
    },
    isToyotaFilter () {
      const type = ['CARS_FOREIGN']
      const mark = ['TOYOTA', 'LEXUS']
      return this.getValueFilter(type, mark)
    },
    isSsangyoungFilter () {
      const type = ['CARS_FOREIGN']
      const mark = ['SSANGYONG']
      return this.getValueFilter(type, mark)
    },
    isAbarthFilter () {
      const type = ['CARS_FOREIGN']
      const mark = ['ABARTH', 'ALFA_ROMEO', 'LANCIA', 'FIAT']
      return this.getValueFilter(type, mark)
    },
    isMercedesFilter () {
      const type = ['CARS_FOREIGN', 'BUS', 'SPECIAL_TECH_FOREIGN', 'ENGINE', 'TRUCKS_FOREIGN']
      const mark = ['MERCEDES_BENZ', 'SMART', 'MERCEDES_BENZ_PS']
      return this.getValueFilter(type, mark)
    },
    isRenaultFilter () {
      const type = ['CARS_FOREIGN']
      const mark = ['RENAULT', 'DACIA']
      return this.getValueFilter(type, mark)
    },
    isInfinityFilter () {
      const type = ['CARS_FOREIGN']
      const mark = ['INFINITI', 'NISSAN']
      return this.getValueFilter(type, mark)
    }
  },
  watch: {
    currentType () {
      this.currentMark = ''
    }
  },
  methods: {
    getValueFilter (type, mark) {
      if (type.indexOf(this.currentType) === -1 || mark.indexOf(this.currentMark) === -1) {
        return false
      } else {
        return true
      }
    },
    getData () {
      let vm = this
      this.$http.get('/acat/').then(response => {
        const data = response.data.data
        vm.responseData = data
        if (Array.isArray(data.types)) {
          vm.dataTypeAndMark = data
        }
      })
    },
    getListFromData (dataList, mapFunction) {
      if (!Array.isArray(dataList) || dataList.length === 0) {
        return []
      }
      return dataList.map(mapFunction)
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style>
    .el-select {
        display: inline-block;
        position: relative;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/vue/components/autoCatalogFilter/AutoCatalogFilter.vue